import { chamadosSuporte, type ChamadoSuporte } from './chamados';

let chamadosData = [...chamadosSuporte];
let ticketCounter = 43;

export function getChamados(): ChamadoSuporte[] {
  return chamadosData;
}

export function getChamadoById(id: string): ChamadoSuporte | undefined {
  return chamadosData.find(c => c.id === id);
}

export function atualizarStatusChamado(id: string, novoStatus: ChamadoSuporte['status']): boolean {
  const idx = chamadosData.findIndex(c => c.id === id);
  if (idx === -1) return false;
  chamadosData[idx] = {
    ...chamadosData[idx],
    status: novoStatus,
    data_atualizacao: new Date().toISOString(),
  };
  return true;
}

export function atribuirResponsavel(id: string, responsavel: string): boolean {
  const idx = chamadosData.findIndex(c => c.id === id);
  if (idx === -1) return false;
  chamadosData[idx] = {
    ...chamadosData[idx],
    responsavel,
    data_atualizacao: new Date().toISOString(),
  };
  return true;
}

export function adicionarResposta(
  id: string,
  resposta: Omit<import('./chamados').RespostaChamado, 'id' | 'data'>
): boolean {
  const idx = chamadosData.findIndex(c => c.id === id);
  if (idx === -1) return false;
  const novaResposta = {
    id: `r-${Date.now()}`,
    ...resposta,
    data: new Date().toISOString(),
  };
  chamadosData[idx] = {
    ...chamadosData[idx],
    respostas: [...chamadosData[idx].respostas, novaResposta],
    data_atualizacao: new Date().toISOString(),
  };
  return true;
}

export function criarChamadoManual(dados: {
  titulo: string;
  descricao: string;
  tipo: ChamadoSuporte['tipo'];
  prioridade: ChamadoSuporte['prioridade'];
  usuario_tipo: ChamadoSuporte['usuario_tipo'];
  usuario_nome: string;
  usuario_email: string;
  responsavel: string;
  canal_origem?: string;
}): string {
  const novoId = `TK-2026-${String(ticketCounter).padStart(4, '0')}`;
  ticketCounter += 1;

  const novoChamado: ChamadoSuporte = {
    id: novoId,
    titulo: dados.titulo,
    descricao: dados.descricao,
    tipo: dados.tipo,
    status: 'aberto',
    prioridade: dados.prioridade,
    usuario_tipo: dados.usuario_tipo,
    usuario_nome: dados.usuario_nome,
    usuario_email: dados.usuario_email,
    responsavel: dados.responsavel,
    canal_origem: dados.canal_origem,
    data_criacao: new Date().toISOString(),
    data_atualizacao: new Date().toISOString(),
    respostas: [],
  };

  chamadosData.unshift(novoChamado);

  // Criar conversa de ticket associada na lista de atendimento
  import('./conversasCanais').then(({ conversasData: cd }) => {
    const novaConversa = {
      id: novoId,
      canal: 'ticket' as const,
      usuario_nome: dados.usuario_nome,
      usuario_email: dados.usuario_email,
      usuario_tipo: dados.usuario_tipo,
      titulo: dados.titulo,
      status: 'aberto' as const,
      prioridade: dados.prioridade,
      responsavel: dados.responsavel,
      ticket_id: novoId,
      origem_manual: dados.canal_origem,
      data_criacao: new Date().toISOString(),
      data_atualizacao: new Date().toISOString(),
      respostas: [],
    };
    cd.unshift(novaConversa);
  });

  return novoId;
}

export function getBackofficeUsersList(): { id: string; nome: string; role: string }[] {
  return [
    { id: 'adm-001', nome: 'Administrador Geral', role: 'admin' },
    { id: 'sup-001', nome: 'Ana Souza', role: 'suporte' },
    { id: 'fin-001', nome: 'Carlos Mendes', role: 'financeiro' },
    { id: 'op-001', nome: 'Mariana Lima', role: 'operador' },
  ];
}